import React, { Component } from 'react';
import * as styles from './forgetPasswordStyles';
import * as Yup from 'yup';
import { FormInput } from '../../../common';
import { Formik } from 'formik';
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Label
} from 'semantic-ui-react';
import { messages } from '../../../../utils';

const { validation } = messages;

class ForgetPassword extends Component {
  onSubmitBtnClick(values) {
    const { handleSubmitBtn } = this.props;
    handleSubmitBtn(values);
  }
	render() {
    const { isLoading, onCreateAccount } = this.props;
		return (
      <div style={{marginTop: '10px'}}>
  <Grid centered columns={2}>
    <Grid.Column>
      <Header as="h2" textAlign="center">
        Reset Password
      </Header>
      <p style={{textAlign:'center'}}>Please enter your email address and we'll send you a password reset</p>
      <Segment>
        <Form size="large">
          <Formik
            initialValues={{ email: '' }}
            onSubmit={values => this.onSubmitBtnClick(values)}
            validationSchema={
              Yup.object().shape({
                email: Yup.string().email(validation.invalidEmail).max(100, "Maximum characters exceed 100").required(validation.requiredField),
              })
            }
            render={({
              values,
              handleSubmit,
              setFieldValue,
              errors,
              touched,
            }) => (
              <div>
                <div className="row">
                  <div className="col-sm">
                  {errors.email && touched.email && <Label>
                      {errors.email}
                    </Label>}
                    <FormInput
                     style={{marginBottom:'10px'}}
                     value={values.email}
                     fluid
                      icon="user"
                      iconPosition="left"
                      placeholder="Email address"
                     onChange={(event,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                      required
                      name='email'
                      type='text'
                    />
                  </div>
                </div>
                

                <div className="row">
                
                  <div className="col-sm text-right">
                  <Button loading={isLoading} color="blue" type="submit" fluid size="large" onClick={() => handleSubmit(values)}>Reset Password</Button>
                  </div>
                </div>
                </div>
            )}
          />
        </Form>
      </Segment>
      <Message>
      Not registered yet? <a  href="#" onClick={onCreateAccount}>Sign Up</a>
      </Message>
    </Grid.Column>
  </Grid>
      </div>
		);
	}
}

export default ForgetPassword;